import api from './client';

export interface ProductPair {
  product_a_id: number;
  product_a_title: string;
  product_a_price: number | null;
  product_b_id: number;
  product_b_title: string;
  product_b_price: number | null;
  co_occurrence: number;
  attach_rate: number;
}

export type UpsellRecommendationType = 'bundle' | 'cross_sell' | 'post_purchase_upsell';

export interface UpsellRecommendationItem {
  type: UpsellRecommendationType;
  title: string;
  products: string[];
  rationale: string;
  expected_impact: string;
  suggested_discount_percent?: number;
  regular_price?: number;
  bundle_price?: number;
}

export interface UpsellRecommendation {
  id: number;
  period_start: string;
  period_end: string;
  orders_analyzed: number;
  product_pairs: ProductPair[];
  ai_summary: string | null;
  ai_recommendations: UpsellRecommendationItem[];
  ai_model: string | null;
  cost_usd: number;
  created_at: string | null;
}

export interface GenerateUpsellPayload {
  days?: number;
}

export interface UpsellWidgetStatus {
  pairs_count: number;
  last_refreshed_at: string | null;
  total_add_to_carts: number;
}

export const upsellApi = {
  list: (page = 1) =>
    api.get<{ data: UpsellRecommendation[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/upsell?page=${page}`
    ),

  generate: (payload: GenerateUpsellPayload = {}) =>
    api.post<{ data: UpsellRecommendation }>('/upsell/generate', payload),

  show: (id: number) => api.get<{ data: UpsellRecommendation }>(`/upsell/${id}`),

  destroy: (id: number) => api.delete(`/upsell/${id}`),

  widgetStatus: () => api.get<{ data: UpsellWidgetStatus }>('/upsell/widget-status'),

  refreshWidget: (payload: GenerateUpsellPayload = {}) =>
    api.post<{ data: { pairs_count: number } }>('/upsell/refresh-widget', payload),
};
